export interface ProductVariantMetadata {
  [key: string]: any;
  premium_upcharge?: number;
  mise_dish_id?: number;
}

const parseIntOrNull = (data: any) => (isNaN(parseInt(data)) ? null : parseInt(data));

export const parseVariantMetadata = (data: any): ProductVariantMetadata => ({
  ...data,
  premium_upcharge: parseIntOrNull(data.premium_upcharge),
  mise_dish_id: parseIntOrNull(data.premium_upcharge)
});
